// 2nd param set false if you do not want to trigger VirtualPageView
export default function setAndTriggerDataLayer(data, pushDataLayer = true) {
    if (typeof window !== 'undefined') {
        const newDataLayer = { ...window.persistDataLayer, ...data, event: 'VirtualPageView' };
        const { visitorEmail, visitorMobile } = newDataLayer;
        window.persistDataLayer = { visitorEmail, visitorMobile };
        if (pushDataLayer) {
            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push(newDataLayer);
            } else {
                setTimeout(() => {
                    setAndTriggerDataLayer(data, pushDataLayer);
                }, 2000);
            }
        }
    }
}
